export default __webpack_public_path__ + "locales/sk/SingleSignOn.json?hash=714e3e33422466b94155dc36fc7147fd";